import { PositionEnum } from './enums/position.enum';
import { UserTypeEnum } from './enums/user-type.enum';
import { LIST_POSITION, Position } from './position.model';
import { Address, BillAddress } from './address.model';

export class User {
  public id?: number;
  public login?: string;
  public firstName = '';
  public lastName = '';
  public activated?: boolean;
  public civility?: string;
  public userType?: UserTypeEnum;
  public authorities: string[] = [];
  public companyName?: string;
  public siret?: string;
  public vatNumber?: string;
  public phone?: string;
  public email?: string;
  public companyLegalStatus?: string; // TODO: Utiliser une énum ou class
  public companyAddressFullname?: string;
  public companyAddressStreetNumber?: string;
  public companyAddressStreet?: string;
  public companyAddressAdditionals?: string;
  public companyAddressZipCode?: string;
  public companyAddressCity?: string;
  public companyAddressCountry?: string;
  public billAddressFullname?: string;
  public billAddressStreetNumber?: string;
  public billAddressStreet?: string;
  public billAddressAdditionals?: string;
  public billAddressZipCode?: string;
  public billAddressCity?: string;
  public billAddressCountry?: string;
  public billEmail?: string;
  public langKey = 'fr';
  public position?: PositionEnum | Position; //TODO: On ne doit pas utiliser PositionEnum, il faut utiliser l'objet Position
  public dateBirth?: Date;
  public isTemporalPassword?: boolean;
  public createdBy?: string;
  public createdDate!: Date;
  public lastModifiedBy?: string;
  public lastModifiedDate?: Date;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.position = data.position ? LIST_POSITION[data.position] : undefined;
  }

  public get address(): Address {
    return new Address({
      fullname: this.companyAddressFullname,
      street: this.companyAddressStreet,
      streetNumber: this.companyAddressStreetNumber,
      zipCode: this.companyAddressZipCode,
      city: this.companyAddressCity,
      country: this.companyAddressCountry,
      additionals: this.companyAddressAdditionals,
    });
  }

  public get billAddress(): BillAddress {
    return new BillAddress({
      fullname: this.billAddressFullname,
      street: this.billAddressStreet,
      streetNumber: this.billAddressStreetNumber,
      zipCode: this.billAddressZipCode,
      city: this.billAddressCity,
      country: this.billAddressCountry,
      additionals: this.billAddressAdditionals,
      billEmail: this.billEmail,
    });
  }

  public serialize(): any {
    return {
      id: this.id,
      login: this.login,
      firstName: this.firstName,
      lastName: this.lastName,
      activated: this.activated,
      civility: this.civility,
      userType: this.userType,
      authorities: this.authorities,
      companyName: this.companyName,
      siret: this.siret,
      vatNumber: this.vatNumber,
      phone: this.phone,
      email: this.email,
      companyLegalStatus: this.companyLegalStatus,
      companyAddressFullname: this.companyAddressFullname,
      companyAddressStreetNumber: this.companyAddressStreetNumber,
      companyAddressStreet: this.companyAddressStreet,
      companyAddressAdditionals: this.companyAddressAdditionals,
      companyAddressZipCode: this.companyAddressZipCode,
      companyAddressCity: this.companyAddressCity,
      companyAddressCountry: this.companyAddressCountry,
      billAddressFullname: this.billAddressFullname,
      billAddressStreetNumber: this.billAddressStreetNumber,
      billAddressStreet: this.billAddressStreet,
      billAddressAdditionals: this.billAddressAdditionals,
      billAddressZipCode: this.billAddressZipCode,
      billAddressCity: this.billAddressCity,
      billAddressCountry: this.billAddressCountry,
      billEmail: this.billEmail,
      langKey: this.langKey,
      position: this.position instanceof Position ? this.position?.code : this.position,
      dateBirth: this.dateBirth,
      isTemporalPassword: this.isTemporalPassword,
      createdBy: this.createdBy,
      createdDate: this.createdDate,
      lastModifiedBy: this.lastModifiedBy,
      lastModifiedDate: this.lastModifiedDate,
    };
  }
}

export class UserWithPassword extends User {
  public password?: string;

  constructor(data: any = {}) {
    super(data);
    this.password = data.password;
  }

  override serialize(): any {
    const baseSerialization = super.serialize();
    return {
      ...baseSerialization,
      password: this.password,
    };
  }
}
